import { renderKoDataTable, renderKoEmptyState } from '~/components/templates/listPageDataTable';
import { renderRecruitingStatusCell, renderRecruitingTextCell } from '~/components/templates/recruiting/RecruitingTable';
import { html, LpButton, LpTable } from '~/design-system';
const columns = [
    { key: 'id', label: 'ID', width: 88, minWidth: 72, resizable: true },
    { key: 'code', label: 'Code', width: 180, minWidth: 140, resizable: true },
    { key: 'question', label: 'Question', minWidth: 320, resizable: true },
    { key: 'type', label: 'Type', width: 140, minWidth: 112, resizable: true },
    { key: 'status', label: 'Status', width: 128, minWidth: 104, resizable: true },
    { key: 'actions', label: 'Actions', align: 'center', width: 96, minWidth: 88, required: true },
];
export function renderRecruitingQuestionsTable() {
    return renderKoDataTable({
        title: 'Available Questions',
        titleIcon: 'question',
        caption: 'Recruiting questions',
        columns,
        className: 'questions-table recruiting-questions-table',
        children: renderBody(),
    });
}
function renderBody() {
    const codeBinding = '$data.uiQuestionId || $data.uiQuestionID || $data.questionCode || $data.code || ""';
    const questionBinding = '($data.configuration && $data.configuration.label) || $data.label || $data.question || $data.text || ""';
    const typeBinding = '($data.configuration && $data.configuration.inputType && $data.configuration.inputType.inputType) || $data.type || $data.inputType || $data.questionType || ""';
    return html `
        ${LpTable.Body({
        attributes: { 'data-bind': 'foreach: questions' },
        children: LpTable.Row({
            children: html `
                    ${renderRecruitingTextCell({ column: columns[0], binding: 'id' })}
                    ${renderRecruitingTextCell({ column: columns[1], binding: codeBinding })}
                    ${renderRecruitingTextCell({ column: columns[2], binding: questionBinding, clampLines: 3, titleBinding: questionBinding })}
                    ${renderRecruitingTextCell({ column: columns[3], binding: typeBinding })}
                    ${renderRecruitingStatusCell({
                column: columns[4],
                textBinding: '$data.active === false || Number($data.active || 1) === 0 ? "Inactive" : "Active"',
                cssBinding: `
                            'task-status--success': $data.active !== false && Number($data.active || 1) !== 0,
                            'task-status--pending': $data.active === false || Number($data.active || 1) === 0
                        `,
            })}
                    ${LpTable.Cell({ column: columns[5], children: LpButton({ ariaLabel: 'Edit', prefixIcon: 'pencil-simple', size: 'sm', shape: 'square', variant: 'ghost', className: 'list-edit-action', attributes: { 'data-bind': 'click: $parent.onClickEdit' } }) })}
                `,
        }),
    })}
        ${renderKoEmptyState({ colSpan: columns.length, visibleBinding: 'questions().length === 0', title: 'No questions found', description: 'Create a question to use it in question banks.', icon: 'question' })}
    `;
}
